var counterBadge = {
  sizes: {
    small: {
      minWidth: 16,
      height: 16,
      maxWidth: 24
    },
    regular: {
      minWidth: 20,
      height: 20,
      maxWidth: 32
    },
    large: {
      minWidth: 24,
      height: 24,
      maxWidth: 32
    }
  }
};
export default counterBadge;